var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAnnounce = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 1.96875C15.402 1.96875 15.3334 1.98105 15.2648 2.00918L5.13281 6.08027H2.25C2.09531 6.08027 1.96875 6.21035 1.96875 6.37207V11.6279C1.96875 11.7896 2.09531 11.9197 2.25 11.9197H4.0377C3.97266 12.1236 3.9375 12.3398 3.9375 12.5596C3.9375 13.718 4.8832 14.6602 6.04688 14.6602C7.0207 14.6602 7.8416 13.9992 8.08418 13.1062L15.2666 15.9926C15.3352 16.0189 15.4037 16.033 15.4705 16.033C15.7676 16.033 16.033 15.7834 16.033 15.4494V2.55234C16.0312 2.21836 15.7676 1.96875 15.4688 1.96875ZM6.04688 13.3998C5.58105 13.3998 5.20312 13.0236 5.20312 12.5596C5.20312 12.3627 5.27168 12.1746 5.39648 12.0252L6.88887 12.6246C6.85371 13.057 6.48984 13.3998 6.04688 13.3998ZM14.7656 14.4264L5.60391 10.7455L5.37715 10.6541H3.23438V7.3459H5.37715L5.60391 7.25449L14.7656 3.57363V14.4264Z",
    fill: "#0077B8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnnounce, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/announce.9e4f3a43.svg";
export { ForwardRef as ReactComponent };